import { render, staticRenderFns } from "./TipoCaracteristicaForm.vue?vue&type=template&id=0716df4a"
import script from "./TipoCaracteristicaForm.vue?vue&type=script&lang=js"
export * from "./TipoCaracteristicaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports